// extracted by mini-css-extract-plugin
module.exports = {"items":"Agenda_items__klyc6","item":"Agenda_item__dw0Z8","time":"Agenda_time___PjFU"};